import * as Sentry from '@sentry/react';
import { MutationCache, QueryCache, QueryClient } from 'react-query';

type QueryMeta = {
  queryKey: unknown;
  queryHash?: string;
};

type MutationMeta = {
  options: {
    mutationKey?: unknown;
  };
};

const captureReactQueryError = (error: unknown, meta?: { query?: QueryMeta; mutation?: MutationMeta }) => {
  Sentry.withScope((scope) => {
    if (meta?.query) {
      scope.setTag('react_query.type', 'query');
      scope.setExtra('queryKey', meta.query.queryKey);
      scope.setExtra('queryHash', meta.query.queryHash);
    }
    if (meta?.mutation) {
      scope.setTag('react_query.type', 'mutation');
      scope.setExtra('mutationKey', meta.mutation.options.mutationKey);
    }
    Sentry.captureException(error);
  });
};

const queryCache = new QueryCache({
  onError: (error, query) =>
    captureReactQueryError(error, {
      query: {
        queryKey: query.queryKey,
        queryHash: query.queryHash,
      },
    }),
});

const mutationCache = new MutationCache({
  onError: (error, _variables, _context, mutation) =>
    captureReactQueryError(error, {
      mutation: {
        options: {
          mutationKey: mutation.options?.mutationKey,
        },
      },
    }),
});

export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      staleTime: 10_000,
      retry: 1,
    },
    mutations: {
      retry: false,
    },
  },
});
